import { browser } from '$app/environment';

const queue	= $state<(() => Promise<unknown>)[]>([]);

// This is a simple queue to store callbacks to be executed in order.
// Right now, it's used to store saveFavorite callback to be executed after the user is logged in,
// but it could be used to store any other callback to be executed in order.

// Feel free to store also sync methods (to do so, make some change to the run method and the types or maybe promisfy all the methods passed during enqueue)

export function useQueuedCallback() {
	function enqueue(fn: () => Promise<unknown>) {
		if (!browser) return;
		queue.push(fn);
	}

	function dequeue() {
		if (!browser || isQueueEmpty()) return;
		return queue.shift();
	}

	function isQueueEmpty() {
		return queue.length === 0;
	}

	async function runQueue() {
		if (!browser) return;

		while (!isQueueEmpty()) {
			const fn = dequeue();

			if (!fn) break;

			try {
				await fn();
			} catch (error) {
				console.error(error);
			}
		}
	}

	return {
		enqueue,
		dequeue,
		isQueueEmpty,
		runQueue,
	};
}
